import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, XCircle } from 'lucide-react';
export function FailedSolutions() {
  const responses = ['Sí, claro… avísame. (y nunca pasa)', 'Estás exagerando.', 'Pues tú vives más cerca.', 'Yo no sé hacer eso.', '… (silencio total)'];
  return <section className="py-14 px-6 bg-cream" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-13">
            Por qué pedir ayuda "así nomás" no funciona
          </h2>
          <p className="text-lg text-navy/80" data-id="element-14">
            Muchos cuidadores intentan esto: "¿Me pueden ayudar más?", "Yo ya no
            puedo", "Échenme la mano".
            <br data-id="element-15" />
            <br data-id="element-16" />Y la respuesta suele ser:
          </p>
        </motion.div>

        <div className="space-y-3 mb-8" data-id="element-17">
          {responses.map((response, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 p-3 bg-white rounded-lg shadow-sm border border-navy/5" data-id="element-18">
              <MessageCircle className="w-6 h-6 text-terracotta shrink-0 mt-1" data-id="element-19" />
              <p className="text-navy font-medium italic" data-id="element-20">"{response}"</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-sage/10 p-6 rounded-xl border border-sage/20" data-id="element-21">
          <div className="flex gap-4" data-id="element-22">
            <XCircle className="w-8 h-8 text-sage shrink-0" data-id="element-23" />
            <div data-id="element-24">
              <p className="text-navy/90 text-lg leading-relaxed" data-id="element-25">
                No porque tu familia sea "mala" necesariamente… sino porque{' '}
                <span className="font-bold text-navy" data-id="element-26">
                  no hay acuerdos concretos, tareas medibles, ni consecuencias
                  realistas.
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}